import React from "react"

const SourceStatusButton = ({ style, active, children }) => (
    <div
        className={`btn source-status btn-${active ? "active" : "inactive"}`}
        style={style}
    >
        {children || (active ? "Active" : "Inactive")}
    </div>
)

export default SourceStatusButton
